export var SET_SELECTED_CASE_DETAIL_TAB_INDEX = 'SET_SELECTED_CASE_DETAIL_TAB_INDEX';
export var setSelectedCaseDetailTabIndex = function setSelectedCaseDetailTabIndex(tabIndex) {
  return {
    type: SET_SELECTED_CASE_DETAIL_TAB_INDEX,
    payload: tabIndex
  };
};